function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isFunction, isNode, isString } from './type';

/**
 * querySelector under steroid
 * Can use as selector:
 *  - function
 *  - DOM Node
 *  - String
 * @param {String|Node|Function} selector 
 * @param {Node|undefined} node 
 */
export const querySelector = (selector, node) => {
  if (isFunction(selector)) {
    return selector(node);
  }
  if (isNode(selector)) {
    return selector;
  }
  if (isString(selector)) {
    if (!node || !isNode(node) || node.nodeType !== 1) {
      node = document;
    }
    return node.querySelector(selector);
  }
  if (Array.isArray(selector) || typeof NodeList !== 'undefined' && NodeList.prototype.isPrototypeOf(selector)) {
    return selector[0];
  }
};

/** 
 * querySelectorAll under steroid
 * Can use as selector:
 *  - function
 *  - DOM Node
 *  - String
 * @param {String|Node|Function} selector 
 * @param {Node|undefined} node 
 */
export const querySelectorAll = (selector, node) => {
  if (isFunction(selector)) {
    return selector(node);
  }
  if (isNode(selector)) {
    return [selector];
  }
  if (isString(selector)) {
    if (!node || !isNode(node) || node.nodeType !== 1) {
      node = document;
    }
    return node.querySelectorAll(selector);
  }
  if (typeof NodeList !== 'undefined' && NodeList.prototype.isPrototypeOf(selector)) {
    return selector;
  } else {
    return [];
  }
};

// Convert dataset into Object
export const optionsFromDataset = function (node) {
  let defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isNode(node)) {
    return node.dataset ? Object.keys(node.dataset).filter(key => Object.keys(defaultOptions).includes(key)).reduce((obj, key) => {
      return _objectSpread(_objectSpread({}, obj), {}, {
        [key]: node.dataset[key]
      });
    }, {}) : {};
  } else {
    return {};
  }
};

/**
 * Copy HTML attributes from a source element to a target element
 * @param {Node} target 
 * @param {Node} source 
 * @param {String} except list of attributes to skip (separated by space)
 */
export const cloneAttributes = function (target, source) {
  let except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (except !== null) {
    except = except.split(' ');
  }
  [...source.attributes].forEach(attr => {
    if (!except.includes(attr.nodeName)) {
      target.setAttribute(attr.nodeName === "id" ? 'data-id' : attr.nodeName, attr.nodeValue);
    }
  });
};

/**
 * Escapes string for insertion into HTML, replacing special characters with HTML
 * entities.
 * @param {String} string
 */
export const escape = string => {
  return isString(string) ? string.replace(/(['"<>])/g, char => {
    return {
      '<': "&lt;",
      '>': "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }[char];
  }) : string;
};